import _styled from "@emotion/styled-base";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

import React from 'react';
import { jsx } from '@emotion/core';
import { Card, Type } from '../../';
import { COLORS, GRID, FONT } from '../../constants';
import { facepaintMediaQueries } from '../shared';
import { ChangeIndicator } from './ChangeIndicator';
import { LabelWithTooltip } from './Label';
var cardStyles = facepaintMediaQueries({
  display: 'flex',
  flexDirection: 'column',
  padding: [0, 0]
});

var ChildrenContainer = _styled("div", {
  target: "e1bt2y80",
  label: "ChildrenContainer"
})("flex-grow:2;", function (_a) {
  var collapsed = _a.collapsed;
  return {
    padding: collapsed ? 0 : "0 " + GRID.medium + " " + GRID.small
  };
}, process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */");

export var NumberHighlightCard = function NumberHighlightCard(_a) {
  var mainValue = _a.mainValue,
      label = _a.label,
      tooltip = _a.tooltip,
      children = _a.children,
      _b = _a.collapsed,
      collapsed = _b === void 0 ? false : _b,
      change = _a.change; // If there are no children, collapse to remove the extra padding around the empty children

  var hasChildren = React.Children.count(children) > 0;
  collapsed = collapsed || !hasChildren;
  return jsx(Card, {
    css: cardStyles
  }, jsx(Type, {
    css: {
      display: 'flex',
      alignItems: 'center',
      fontSize: '26px',
      lineHeight: '26px',
      fontWeight: FONT.weight.bold,
      margin: GRID.small + " " + GRID.medium
    }
  }, mainValue, change && jsx(ChangeIndicator, __assign({}, change))), jsx(Type, {
    css: {
      display: 'block',
      margin: "0 " + GRID.medium + " " + GRID.small,
      color: COLORS.grays.gray
    }
  }, tooltip ? jsx(LabelWithTooltip, {
    tooltip: tooltip
  }, label) : label), jsx(ChildrenContainer, {
    collapsed: collapsed
  }, children));
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@trustpilot/businessapp-patternlibrary/lib/components/NumberHighlightCard/NumberHighlightCard.js
// module id = 1220
// module chunks = 0